import { useLocation } from "react-router-dom";
import { WorkflowStatusForm } from "../../../components/workflow-status/WorkflowStatusForm";

const EditWorkflowStatus = () => {
  const location = useLocation();
  const workflowStatusData = location.state as { id: number; workflowName: string } | null;

  if (!workflowStatusData) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Workflow Status Not Found</h1>
          <p className="text-muted-foreground mt-2">The requested workflow status could not be found.</p>
        </div>
      </div>
    );
  }

  return <WorkflowStatusForm initialData={workflowStatusData} isEdit />;
};

export default EditWorkflowStatus;